import ApproveLoan from "./ApproveLoan.jsx";

export default ApproveLoan;
